export const mapEventExportData = (events) => {
    return events.map(event => {
      return {
        title: event.title,
        start: new Date(event.date),
      }
    })
  }